export default "__VITE_ASSET__BnyjjHxj__"